module.exports = __webpack_public_path__ + "static/media/YM11_0.582ce1d3.jpg";